// Trello default height for items is 49 px
export const worklogListItemFixedHeight = 49;
// timeline 20px + padding 4px
export const worklogTimelineHeight = 24;
export const cardNameHeight = 20;
export const commentMarginHeight = 10;
export const commentBlockHeight = 28;
export const dividerHeight = 7;
